// extracted by mini-css-extract-plugin
module.exports = {"theComp":"SmoothlyB_theComp__1vN7s"};